import React, { useState, forwardRef } from "react";
import { ReactComponent as CameraSvg } from "../svgs/camera.svg";
import { TakePhoto } from "./TakePhoto";
import { ViewBucketPhoto } from "./ViewBucketPhoto";
import { createPortal } from "react-dom";

export const SortBucket = forwardRef(
  (
    {
      heading,
      description,
      onPhotoCaptured,
      picture,
      label,
      placeholder,
      isRequired,
    },
    ref
  ) => {
    const [showCamera, setShowCamera] = useState(false);

    const onPhotoTaken = (picture) => {
      setShowCamera(false);
      onPhotoCaptured(picture);
    };

    const onCancel = () => {
      setShowCamera(false);
    };

    return (
      <>
        <div className="flex flex-col items-center gap-2">
          <button
            ref={ref}
            className={`flex relative overflow-hidden items-center justify-center rounded-xl bg-[#0B1C47] border-2 border-transparent h-[160px] w-[220px] ${picture ? "p-0" : "p-12"} hover:bg-[#282F44] transition-colors`}
            onClick={() => {
              setShowCamera(true);
            }}
          >
            {placeholder && (
              <img
                src={placeholder}
                alt={`${heading} placeholder`}
                className="absolute inset-0 h-full w-full object-cover"
              />
            )}
            {picture ? (
              <img
                src={picture}
                alt={`Captured ${heading}`}
                className="relative rounded-lg h-full w-full object-cover"
              />
            ) : !picture ? (
              <div
                className={`flex flex-col items-center bg-black/10 backdrop-blur-md py-2 px-3 rounded-xl ${isRequired ? "border-2 border-[#17E0C2]" : ""}`}
              >
                <CameraSvg className="w-12 h-12 fill-white/90" />
                {label && (
                  <span className="text-[12px] text-white/70 font-medium">
                    {label}
                  </span>
                )}
              </div>
            ) : null}
          </button>
          <div className="flex flex-col items-center gap-1 w-[200px] h-[80px]">
            <p className="font-bold text-[20px] text-white leading-[26px] text-center">
              {heading}
            </p>
            <p className="text-[14px] text-[#C6CCE8] leading-[18px] text-center">
              {description}
            </p>
          </div>
        </div>
        {showCamera && !picture ? (
          <TakePhoto
            title={heading}
            description={description}
            onPhotoTaken={onPhotoTaken}
            onCancel={onCancel}
            showGuidance={true}
            bucketPlaceholder={placeholder}
          />
        ) : null}
        {showCamera && Boolean(picture)
          ? createPortal(
              <ViewBucketPhoto
                title={heading}
                photo={picture}
                onDelete={() => {
                  onPhotoCaptured("");
                }}
                onClose={() => {
                  setShowCamera(false);
                }}
              />,
              document.body
            )
          : null}
      </>
    );
  }
);
